import { graphql } from "relay-runtime"

export const deTherapyPrescriptionFragment = graphql`
  fragment deTherapyPrescriptionFragment on de_TherapyPrescription {
    id
    treatmentUnit
    frequency
    requestTherapyReport
    diagnosisCode
    symptoms
    otherSymptoms
    additionalInformation
    progressNoteId
    signedBy
    signedAt
    updatedAt
    updatedBy
    createdAt
    createdBy
    concludedAt
    concludedBy
    therapy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
